export default "/images/vendor/flag-icon-css/flags/1x1/bn.svg?91c0cc951477ac7e6db373711b63e5c0";